import React, { useState } from "react";
import { Container, Carousel, Row, Col } from "react-bootstrap";

const data = [
  {
    id: 1,
    title: "Understand the Product and Scope",
    description:
      "We review workflows, user actions and critical areas to identify what needs testing and where risks exist.",
  },
  {
    id: 2,
    title: "Define the Test Strategy",
    description:
      "The approach is shaped based on the product, release cycle, and required test coverage.",
  },
  {
    id: 3,
    title: "Prepare Test Cases",
    description:
      "We create test scenarios based on real usage, expected behavior and edge cases.",
  },
  {
    id: 4,
    title: "Execute Testing",
    description:
      "Testing is carried out across functionality, regression, integrations, and performance where needed.",
  },
  {
    id: 5,
    title: "Log and Validate Fixes",
    description:
      "Issues are documented clearly and retested after fixes to ensure stability.",
  },
  {
    id: 6,
    title: "Support Release Readiness",
    description:
      "We validate key flows and confirm that the application is ready for release.",
  },
  {
    id: 7,
    title: "Continue Quality Checks",
    description:
      "QA continues across releases to reduce regressions and maintain consistency.",
  },
];

// Function to group items per slide
const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

export default function QaTestingCarousel() {
  const [index, setIndex] = useState(0);

  const itemsPerSlide = 3;
  const slides = chunkArray(data, itemsPerSlide);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <section className="padding-section-large approach-section bg-dark text-white">
      <Container>
        {/* Header */}

        <Row className='mb-4 pt-5 align-items-end mb-5'>
          <Col md={10}>
            <h2 className="heading-style-h2 pb-3">Our Approach to <span className="text-gradient-1">QA and Testing</span></h2>
            <h5 className='heading-style-h5'>How we plan, execute and improve testing to keep software reliable and release-ready.</h5>
          </Col>
          <Col md={2}>
            <div className="carousel-controls pb-3">
              <button className="nav-btn" onClick={() =>
                setIndex((index - 1 + slides.length) % slides.length)
              }>
                ‹
              </button>
              <button className="nav-btn" onClick={() => setIndex((index + 1) % slides.length)}>
                ›
              </button>
            </div>
          </Col>
        </Row>
        {/* Carousel */}
        <Carousel
          activeIndex={index}
          onSelect={handleSelect}
          controls={false}
          indicators={false}
          interval={null}
        >
          {slides.map((slide, slideIndex) => (
            <Carousel.Item key={slideIndex}>
              <Row>
                {slide.map((item) => (
                  <Col md={4} key={item.id} className="mb-4">
                    <div className="approach-card d-flex justify-content-between flex-column">
                      <div>
                        <h4 className="heading-style-h4 text-gradient-1">{item.id}</h4>
                        <h4 className="heading-style-h4 pb-5">{item.title}</h4>
                      </div>
                      <p>{item.description}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
        <Row>
          <div className='bg-gradient-2 text-white p-4 mx-auto text-center w-auto mt-5'>
            <p className='mb-0'>The focus is on making sure software works reliably in real use, not just in test cases.</p>
          </div>
        </Row>
      </Container>
    </section >
  );
}